import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/lib/i18n";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import AuthPage from "@/pages/AuthPage";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import Invoices from "@/pages/Invoices";
import InvoiceNew from "@/pages/InvoiceNew";
import InvoiceView from "@/pages/InvoiceView";
import Expenses from "@/pages/Expenses";
import Accounts from "@/pages/Accounts";
import Journal from "@/pages/Journal";
import Ledger from "@/pages/Ledger";
import Reports from "@/pages/Reports";
import Vat201 from "@/pages/Vat201";
import Settings from "@/pages/Settings";
import PaymentResult from "@/pages/PaymentResult";
import AdminContacts from "@/pages/AdminContacts";
import AdminFormation from "@/pages/AdminFormation";
import Formation from "@/pages/Formation";
import DossierTracker from "@/pages/DossierTracker";
import PublicInvoice from "@/pages/PublicInvoice";
import Quotes from "@/pages/Quotes";
import QuoteView from "@/pages/QuoteView";
import CreditNoteView from "@/pages/CreditNoteView";
import Bank from "@/pages/Bank";
import Recurring from "@/pages/Recurring";
import Payroll from "@/pages/Payroll";
import ClientPortal from "@/pages/ClientPortal";
import PublicQuote from "@/pages/PublicQuote";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center text-slate-400">…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/creation-entreprise" element={<Formation />} />
            <Route path="/dossier/:token" element={<DossierTracker />} />
            <Route path="/i/:token" element={<PublicInvoice />} />
            <Route path="/q/:token" element={<PublicQuote />} />
            <Route path="/c/:token" element={<ClientPortal />} />
            <Route path="/login" element={<AuthPage mode="login" />} />
            <Route path="/register" element={<AuthPage mode="register" />} />
            <Route element={<Protected><Layout /></Protected>}>
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="invoices" element={<Invoices />} />
              <Route path="invoices/new" element={<InvoiceNew />} />
              <Route path="invoices/:id" element={<InvoiceView />} />
              <Route path="invoices/:id/edit" element={<InvoiceNew />} />
              <Route path="quotes" element={<Quotes />} />
              <Route path="quotes/new" element={<InvoiceNew kind="quote" />} />
              <Route path="quotes/:id" element={<QuoteView />} />
              <Route path="credit-notes/:id" element={<CreditNoteView />} />
              <Route path="bank" element={<Bank />} />
              <Route path="recurring" element={<Recurring />} />
              <Route path="payroll" element={<Payroll />} />
              <Route path="clients" element={<Clients />} />
              <Route path="expenses" element={<Expenses />} />
              <Route path="accounts" element={<Accounts />} />
              <Route path="journal" element={<Journal />} />
              <Route path="ledger" element={<Ledger />} />
              <Route path="reports" element={<Reports />} />
              <Route path="vat" element={<Vat201 />} />
              <Route path="vat-201" element={<Navigate to="/vat" replace />} />
              <Route path="settings" element={<Settings />} />
              <Route path="payment/success" element={<PaymentResult outcome="success" />} />
              <Route path="payment/cancel" element={<PaymentResult outcome="cancel" />} />
              <Route path="admin/contacts" element={<AdminContacts />} />
              <Route path="admin/formation" element={<AdminFormation />} />
            </Route>
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-center" />
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
